import {
  Activity, LayoutTemplate, Store, Package, ShieldCheck, Wallet, Sparkles, LifeBuoy, Scale,
} from 'lucide-react';

// `perm` mirrors the backend RBAC matrix (services/admin_security/rbac.py) to hide
// options the role can't use. It is NOT a security control: the API enforces it.
export const ADMIN_MODULES = [
  { key: 'home', label: 'Inicio y monitoreo', icon: Activity, items: [
    { id: 'infra', label: 'Salud de infraestructura', perm: 'infra.view' },
    { id: 'stats', label: 'Estadísticas generales', perms: ['stats.users', 'stats.catalog'] },
    { id: 'storage', label: 'Almacenamiento R2', perm: 'storage.read' },
    { id: 'infra-settings', label: 'Alertas y configuración', perm: 'infra.view' },
  ] },
  { key: 'content', label: 'Contenido y frontend', icon: LayoutTemplate, items: [
    { id: 'pending-logo', label: 'Logo del sitio', perm: 'content.manage', pending: 'El backend ya expone /api/admin/settings/logo; falta su pantalla.' },
  ] },
  { key: 'vendors', label: 'Vendedores, tiendas y KYC', icon: Store, items: [
    { id: 'sellers', label: 'Solicitudes y KYC', perm: 'kyc.read' },
    { id: 'vendors', label: 'Tiendas', perm: 'vendors.read' },
  ] },
  { key: 'catalog', label: 'Productos y categorías', icon: Package, items: [
    { id: 'products', label: 'Productos', perm: 'products.read' },
    { id: 'pending-categories', label: 'Categorías', perm: 'categories.manage', pending: 'Las categorías son hoy una lista fija del frontend comercial; no hay gestión desde el panel.' },
  ] },
  { key: 'security', label: 'Seguridad y administradores', icon: ShieldCheck, items: [
    { id: 'users', label: 'Usuarios', perm: 'users.read' },
    { id: 'admins', label: 'Administradores y roles', perm: 'admins.manage' },
    { id: 'audit', label: 'Auditoría', perm: 'audit.read' },
  ] },
  { key: 'finance', label: 'Finanzas y planes', icon: Wallet, items: [
    { id: 'finance', label: 'Pagos, créditos y planes', perm: 'finance.read' },
  ] },
  { key: 'vton', label: 'Probador virtual (VTON)', icon: Sparkles, items: [
    { id: 'vton', label: 'Estado y configuración', perm: 'vton.read' },
  ] },
  { key: 'support', label: 'Soporte y reportes', icon: LifeBuoy, items: [
    { id: 'support', label: 'Tickets de soporte', perm: 'support.manage' },
    { id: 'complaints', label: 'Libro de Reclamaciones', perm: 'complaints.manage' },
  ] },
  { key: 'legal', label: 'Documentos legales', icon: Scale, items: [
    { id: 'legal-docs', label: 'Términos, privacidad y cookies', perm: 'legal.read' },
  ] },
];

export const visibleModules = (can) => ADMIN_MODULES
  .map((m) => ({ ...m, items: m.items.filter((i) => (i.perms ? i.perms.some(can) : !i.perm || can(i.perm))) }))
  .filter((m) => m.items.length > 0);

export const findItem = (id) => {
  for (const m of ADMIN_MODULES) {
    const item = m.items.find((i) => i.id === id);
    if (item) return { module: m, item };
  }
  return null;
};
